var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArcIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10H2C1.73478 10 1.48043 9.89469 1.29289 9.70715C1.10536 9.51962 1 9.26526 1 9.00005V2.50005C1 2.23483 1.10536 1.98048 1.29289 1.79294C1.48043 1.6054 1.73478 1.50005 2 1.50005H3.95C4.11724 1.49841 4.28223 1.53874 4.42985 1.61736C4.57747 1.69597 4.70302 1.81036 4.795 1.95005L5.2 2.55005C5.29105 2.68831 5.41501 2.80181 5.56075 2.88035C5.70649 2.95889 5.86945 3.00002 6.035 3.00005H10C10.2652 3.00005 10.5196 3.1054 10.7071 3.29294C10.8946 3.48048 11 3.73483 11 4.00005M8 7V8L8.5 8.5M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8Z",
    stroke: "#525062",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcIcon);
export default __webpack_public_path__ + "static/media/arcIcon.8e02846b196d3bf37f177a85ec5f43f7.svg";
export { ForwardRef as ReactComponent };